<form class="lp-product-request-edit" [formGroup]="form">
  <div *ngIf="mode === 'create'" [ngClass]="isMobile ? 'text_size-s' : 'text_size-m'">
    <div>{{ 'components.lpProductRequestInfo.labels.createTitleRow1' | translate }}</div>
    <div>{{ 'components.lpProductRequestInfo.labels.createTitleRow2' | translate }}</div>
  </div>

  <div class="lp-product-request-edit__block">
    <tui-input
      tuiAutoFocus
      tabindex="1"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      formControlName="name"
      [tuiTextfieldSize]="tuiElementLargeSize"
    >
      {{ 'components.lpProductRequestInfo.fields.name' | translate }}
      <span class="tui-required"></span>
      <input tuiTextfieldLegacy [placeholder]="'components.lpProductRequestInfo.fields.namePlaceholder' | translate" />
    </tui-input>

    <tui-input
      tabindex="2"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      formControlName="location"
      [tuiTextfieldSize]="tuiElementLargeSize"
    >
      {{ 'components.lpProductRequestInfo.fields.location' | translate }}
      <span class="tui-required"></span>
      <input
        tuiTextfieldLegacy
        [placeholder]="'components.lpProductRequestInfo.fields.locationPlaceholder' | translate"
      />
    </tui-input>

    <tui-textarea
      tabindex="3"
      formControlName="webLink"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [tuiTextfieldSize]="tuiElementLargeSize"
      [expandable]="true"
      [maxLength]="255"
    >
      {{ 'components.lpProductRequestInfo.fields.webLink' | translate }}
    </tui-textarea>

    <tui-input
      tabindex="4"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      formControlName="mapLink"
      [tuiTextfieldSize]="tuiElementLargeSize"
    >
      {{ 'components.lpProductRequestInfo.fields.mapLink' | translate }}
    </tui-input>

    <tui-textarea
      tabindex="5"
      formControlName="reasonText"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [tuiTextfieldSize]="tuiElementLargeSize"
      [expandable]="true"
      [maxLength]="255"
    >
      {{ 'components.lpProductRequestInfo.fields.reasonText' | translate }}
    </tui-textarea>

    <tui-textarea
      tabindex="6"
      formControlName="managerContact"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [tuiTextfieldSize]="tuiElementLargeSize"
      [expandable]="true"
      [maxLength]="500"
    >
      {{ 'components.lpProductRequestInfo.fields.managerContact' | translate }}
    </tui-textarea>

    <app-field-wrapper
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [size]="tuiElementMediumSize"
      [text]="'components.lpProductRequestInfo.fields.readyToPromote' | translate"
      [pseudoDisabled]="form.controls.readyToPromote.disabled"
    >
      <app-toggle tabindex="7" [size]="'m'" formControlName="readyToPromote"></app-toggle>
    </app-field-wrapper>

    <tui-textarea
      *ngIf="form.controls.readyToPromote.value"
      tabindex="8"
      formControlName="userContactsText"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [tuiTextfieldSize]="tuiElementLargeSize"
      [expandable]="true"
      [maxLength]="255"
    >
      {{ 'components.lpProductRequestInfo.fields.userContactsText' | translate }}
      <textarea
        tuiTextfieldLegacy
        [placeholder]="'components.lpProductRequestInfo.fields.userContactsTextPlaceholder' | translate"
      ></textarea>
    </tui-textarea>
  </div>

  <ng-container *ngIf="mode === 'edit'">
    <div *ngxPermissionsOnly="['loyaltyProgramProductRequestEditing']" class="lp-product-request-edit__block">
      <tui-select
        tabindex="9"
        formControlName="status"
        [valueContent]="statusTypes ? statusTypesStringify(statusTypes) : ''"
        [tuiTextfieldSize]="tuiElementLargeSize"
        [class.tui-skeleton]="loading"
        [class.tui-skeleton_text]="loading"
      >
        {{ 'components.lpProductRequestInfo.fields.status' | translate }}
        <tui-data-list *tuiDataList>
          <button *ngFor="let statusType of statusTypes" tuiOption [value]="statusType.id">
            {{ statusType.value | translate }}
          </button>
        </tui-data-list>
      </tui-select>

      <div tuiGroup class="field-group">
        <tui-input-date
          tabindex="10"
          formControlName="commentDay"
          [tuiTextfieldSize]="tuiElementLargeSize"
          [class.tui-skeleton]="loading"
          [class.tui-skeleton_text]="loading"
        >
          {{ 'components.lpProductRequestInfo.fields.commentDay' | translate }}
        </tui-input-date>

        <tui-input-time
          tabindex="11"
          formControlName="commentTime"
          [items]="timeItems"
          [tuiTextfieldSize]="tuiElementLargeSize"
          [tuiDropdownMobile]="'components.lpProductRequestInfo.fields.commentTime' | translate"
          [class.tui-skeleton]="loading"
          [class.tui-skeleton_text]="loading"
        >
          {{ 'components.lpProductRequestInfo.fields.commentTime' | translate }}
        </tui-input-time>
      </div>
    </div>

    <div class="lp-product-request-edit__block">
      <tui-textarea
        tabindex="12"
        formControlName="comment"
        [class.tui-skeleton]="loading"
        [class.tui-skeleton_text]="loading"
        [tuiTextfieldSize]="tuiElementLargeSize"
        [expandable]="true"
        [maxLength]="500"
      >
        {{ 'components.lpProductRequestInfo.fields.comment' | translate }}
      </tui-textarea>
    </div>
  </ng-container>

  <div *ngIf="!loading" class="lp-product-request-edit__buttons">
    <button
      tuiButton
      tabindex="13"
      type="button"
      appearance="primary"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [size]="tuiElementLargeSize"
      (click)="onClickSaveButton()"
    >
      {{ 'common.buttons.send' | translate }}
    </button>

    <button
      tuiButton
      tabindex="14"
      type="button"
      appearance="secondary"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [size]="tuiElementLargeSize"
      (click)="cancelEdit.emit()"
    >
      {{ 'common.buttons.cancel' | translate }}
    </button>
  </div>
</form>
